import React, {useEffect, useState} from 'react';
import {IonPage, IonContent} from '@ionic/react';
import EventsCard from "../components/EventsCard";
import useStore from "../zustand/useStore";
import {FacebookLoader} from "../components/Loader/FacebookLoader";
import NoDataFoundOrSelectedDiv from "../components/NoDataFoundOrSelectedDiv";
import {
    actionToGetEventDataById,
    actionToGetMemberPanelEventsByFilter
} from "../apiHelpers/CommonAction";
import EventDetailModal from "../components/EventDetailModal";
import EventRegistrationModal from "../components/EventRegistrationModal";
import EventTransactionListModal from "../components/EventTransactionListModal";
import {useParams} from "react-router";

export default function EventsMobilePage({ renderHeaderPage}) {
    const { eventsDataState } = useStore();
    const { eventsData, loading,totalCount } = eventsDataState;
    const isFetchingRef = React.useRef(false); // prevent multiple calls
    const observerRef = React.useRef(null);
    const [isOpenRegisterEventModalPopup,setIsOpenRegisterEventModalPopup] = React.useState(false);
    const [eventRegisterData,setEventRegisterData] = React.useState(null);
    const [eventDetailData,setEventDetailData] = React.useState(null);
    const {isEventDetailOpen,setIsEventDetailOpen} = useStore();
    const [isTransactionListOpen, setIsTransactionListOpen] = useState(false);
    const [transactionsDataList, setTransactionsDataList] = useState(null);
    const {id} = useParams();

    useEffect(()=>{
        if(id) {
            actionToGetEventDataById(id).then((eventData)=>{
                if(eventData?.id) {
                    setEventDetailData(eventData);
                    setIsEventDetailOpen(true);
                }
            });
            setTimeout(()=>{
                window.history.pushState({},null,`${window.location.origin}/dashboard/events`);
            },1000)
        }
    },[id])

    const openTransactionListModal = (data)=>{
        setTransactionsDataList(data);
        setIsTransactionListOpen(true);
    }

    const closeTransactionListModal = ()=>{
        setTransactionsDataList(null);
        setIsTransactionListOpen(false);
    }

    const callFunctionToFilterEventsData = async (isLoad = true)=>{
        if (isFetchingRef.current) return;
        isFetchingRef.current = true;
        await actionToGetMemberPanelEventsByFilter(isLoad);
        isFetchingRef.current = false;
    }

    const openRegisterToEventModal = (event)=>{
        setEventRegisterData(event)
        setIsOpenRegisterEventModalPopup(true)
    }

    const closeRegisterToEventModal = ()=>{
        setEventRegisterData(null)
        setIsOpenRegisterEventModalPopup(false)
    }

    const lastEventsElementRef = React.useCallback(
        (node) => {
            if (observerRef.current) observerRef.current.disconnect();

            observerRef.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && eventsData?.length < totalCount) {
                    callFunctionToFilterEventsData(false); // Load next page
                }
            });

            if (node) observerRef.current.observe(node);
        },
        [callFunctionToFilterEventsData,eventsData,totalCount]
    );


    useEffect(() => {
        callFunctionToFilterEventsData();
    },[])

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent
                fullscreen
                className="events-content page-content"
            >
                <div className="mobile-contain-feed-events">
                    {(loading) ?
                        <div className="job-list">
                            <div className="job-card">
                                <FacebookLoader type={"facebookStyle"} item={1}/>
                            </div>
                            <div className="job-card">
                                <FacebookLoader type={"facebookStyle"} item={1}/>
                            </div>
                            <div className="job-card">
                                <FacebookLoader type={"facebookStyle"} item={1}/>
                            </div>
                        </div>
                        :
                        (eventsData && eventsData?.length > 0) ?
                            <>
                                {eventsData.map((event, index) => {
                                    if (index === eventsData.length - 1) {
                                        return (
                                            <div ref={lastEventsElementRef} key={event.id}>
                                                <EventsCard event={event}
                                                            openTransactionListModal={openTransactionListModal}
                                                            setEventDetailData={setEventDetailData}
                                                            openRegisterToEventModal={openRegisterToEventModal}
                                                            setIsEventDetailOpen={setIsEventDetailOpen}/>
                                            </div>
                                        );
                                    }
                                    return (
                                        <EventsCard key={event.id}
                                                    event={event}
                                                    openTransactionListModal={openTransactionListModal}
                                                    openRegisterToEventModal={openRegisterToEventModal}
                                                    setEventDetailData={setEventDetailData}
                                                    setIsEventDetailOpen={setIsEventDetailOpen}/>
                                    );
                                })}
                            </>
                            :
                            <div className="job-list">
                                <NoDataFoundOrSelectedDiv/>
                            </div>
                    }
                </div>
            </IonContent>

            {(isEventDetailOpen) ?
                <EventDetailModal isOpen={isEventDetailOpen}
                                  openTransactionListModal={openTransactionListModal}
                                  openRegisterToEventModal={openRegisterToEventModal}
                                  eventDetailData={eventDetailData}
                                  onDidDismiss={() => {
                                      setEventDetailData(null);
                                      setIsEventDetailOpen(false)
                                  }}
                />
                : ''
            }
            {(isOpenRegisterEventModalPopup) ?
                <EventRegistrationModal isOpen={isOpenRegisterEventModalPopup}
                                        onDismiss={()=>closeRegisterToEventModal()}
                                        eventRegisterData={eventRegisterData}
                />:''
            }

            {(isTransactionListOpen && transactionsDataList?.length) ?
                <EventTransactionListModal
                    isOpen={isTransactionListOpen}
                    onDidDismiss={() => closeTransactionListModal(false)}
                    title="Event Transactions"
                    transactions={transactionsDataList}
                />:''
            }
        </IonPage>
    );
}

